module.exports = __webpack_public_path__ + "media/כיתה.c929cb25.mp3";